import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import Svg, { SvgEnum } from "../../../ui library/components/svgs/standard/svg";
import Colors from "../../../global/Colors";

const Search = ({ id, filters, updateFilter, placeholder }) => {
  const [searchValue, setSearchValue] = useState("");
  const [userTyping, setUserTyping] = useState();

  useEffect(() => {
    let active = true;
    if (active) {
      if (!filters.get("search")) {
        setSearchValue("");
      }
    }
    return () => {
      active = false;
    };
  }, [filters]);

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid " + Colors.purple[800],
        borderRadius: "35px",
        width: "100%",
        height: "80%",
      }}
    >
      <div className="inline-flex align-center content-center">
        <div className="my-2 pt-1 px-2 border-r-2 border-solid border-purple-800">
          <Svg name={SvgEnum.HisMagnifyingGlass} color="#4C2AC6" />
        </div>
      </div>

      <TextField
        className="placeholder:text-center w-full rounded-lg text-sm"
        placeholder={placeholder ? placeholder : "Search"}
        size="small"
        name="case-search"
        value={searchValue}
        InputLabelProps={{
          shrink: true,
          style: {
            border: "none",
          },
        }}
        onChange={(event) => {
          setSearchValue(event.target.value);
          clearTimeout(userTyping);
          setUserTyping(
            setTimeout(() => {
              updateFilter("search", event.target.value);
            }, 1000)
          );
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
    </div>
  );
};
export default Search;
